module.exports = __webpack_public_path__ + "img/id.13ce9896.jpg";